// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Pq7PP","buttons":"styles_buttons__1n-vD"};